import axios from "axios";
import api from "./axiosClient";

export function getVendors(data) {
  return api.post(`/vendors/get`, { ...data }, { withCredentials: true });
}
// shopkeeper
export function ActivateShops(id, data) {
  return api.post(`/shops/activate/${id}`, data, { withCredentials: true });
}
export function DeactivateShops(id, data) {
  return api.post(`/shops/deactivate/${id}`, data, { withCredentials: true });
}
export function EditShop(id, data) {
  return api.patch(`/shops/${id}`, data, { withCredentials: true });
}
export function ChangeModerator(id, salesman) {
  return api.patch(`/shops/moderator/${id}`, { salesman }, { withCredentials: true });
}

// user
export function AddtechUser(data) {
  return api.post(`/user/create-tech-user`, data, { withCredentials: true });
}
export function AddAdminUser(data) {
  return api.post(`/user/create-admin-user`, data, { withCredentials: true });
}
export function DeactivateTechUser(id) {
  return api.post(`/user/tech-bazaar-user/deactivate/${id}`, {}, { withCredentials: true });
}
export function ActivateTechUser(id) {
  return api.post(`/user/tech-bazaar-user/activate/${id}`, {}, { withCredentials: true });
}
export function DeactivateSellerUser(id) {
  return api.post(`/user/seller-user/deactivate/${id}`, {}, { withCredentials: true });
}
export function ActivateSellerUser(id) {
  return api.post(`/user/seller-user/activate/${id}`, {}, { withCredentials: true });
}
export function editAdmin(data) {
  const { id, ...remData } = data;

  return api.patch(`user/admin-user/${id}`, remData, { withCredentials: true });
}
export function editTechUser(id, data) {
  return api.patch(`user/tech-user/${id}`, data, { withCredentials: true });
}
export function changePassword(id, data) {
  return api.patch(`user/change-password/${id}`, { password: data }, { withCredentials: true });
}

// plans
export function AddPlan(data) {
  return api.post(`/subscriptions/plans`, data, { withCredentials: true });
}
export function EditPLan(id, data) {
  return api.patch(`/subscriptions/plans/${id}`, data, {
    withCredentials: true,
  });
}

// request
export function AddRequest(data) {
  return api.post(`/request/create`, data, { withCredentials: true });
}
export function AddNote(id, data) {
  return api.post(`/request/notes/${id}`, { notes: data }, { withCredentials: true });
}
export function AssignMee(id, data) {
  return api.post(`/request/assign/${id}`, { support: data }, { withCredentials: true });
}
export function cancelRequest({ id, status }) {
  return api.patch(`/request/status/${id}`, { status }, { withCredentials: true });
}

// subscription

export function SubmitShiftPlan(id, data) {
  return api.post(`/transactions/lock/${id}`, data, { withCredentials: true });
}
export function TrialExpired(id) {
  return api.patch(`/subscriptions/trial-expire/${id}`, {}, { withCredentials: true });
}
export function ChangePlan(transaction) {
  const id = transaction.shop_id;
  return api.post(`/subscriptions/change-plan/${id}`, { transaction }, { withCredentials: true });
}
export function PayForNextPlan(transaction) {
  const id = transaction.shop_id;
  return api.post(`/transactions/pay/${id}`, { transaction }, { withCredentials: true });
}

//Themes
export function AddTheme(data) {
  return api.post(`/themes/add`, data, { withCredentials: true });
}
export function EditTheme(id, data) {
  return api.put(`/themes/update/` + id, data, { withCredentials: true });
}

export function DeleteTheme(id) {
  return api.delete(`/themes/` + id, { withCredentials: true });
}

export function GetTheme(id) {
  return api.get(`/themes/` + id, { withCredentials: true });
}
// export fuction ActivateTheme(id) {

// }

// uploadImage

export function UPloadImage(data) {
  return api.post(`${process.env.REACT_APP_URL_IMAGE_CDN}/images/transactions`, data, { withCredentials: true });
}

export function PostData(data) {
  return api.post(`/components`, data, { withCredentials: true });
}

export function EditComponent(id, data) {
  return api.patch(`/components/${id}`, data, { withCredentials: true });
}

export function SendNotification(data) {
  return api.post(`/components`, data, { withCredentials: true });
}

//Banks
export function addBanks(data) {
  return api.post(`/banks`, data, { withCredentials: true });
}
export function editBank(id, data) {
  return api.patch(`/banks/${id}`, data, { withCredentials: true });
}

export function saveProgress(id, data) {
  return api.put(`data-import-requests/validate/${id}/save-progress/`, { data: data }, { withCredentials: true });
}

export function disapprovedRequest(id, data) {
  return api.put(`/data-import-requests/disapprove/${id}`, data, {
    withCredentials: true,
  });
}

export function transformFile(id, userId, mapping) {
  return api.post(`data-import-requests/transform/${id}`, { userId: userId, ...(mapping ? { customMapping: mapping } : {}) }, { withCredentials: true });
}

export function finalize(id, userId) {
  return api.put(`data-import-requests/finalize/${id}`, { userId: userId }, { withCredentials: true });
}

export function AssignTo(id, salesman) {
  return api.put(
    `/become-seller/${id}`, //registration request id
    { request_handled_by: salesman },
    { withCredentials: true },
  );
}

export function AddSellerModule(data) {
  return api.post(`/modules/add`, data, { withCredentials: true });
}

export function editSellerModule(id, data) {
  return api.put(`/modules/update/${id}`, data, { withCredentials: true });
}
export function processPlanRequestCall(id, status) {
  return api.put(`/plan-requests/${id}`, status, { withCredentials: true });
}
export function editConsumableItem(name, data) {
  return api.patch(`addons/pricing/consumable-item/${name}`, { per_unit_price: data }, { withCredentials: true });
}
export function addonsRequest(data) {
  return api.post(`addons/request`, { shop_id: data?.shop_id, is_paid: data?.is_paid, requested_items: data?.requested_items }, { withCredentials: true });
}
export function disapproveAddonsRequest(id, status) {
  return api.patch(`addons/request/${id}/status`, status, {
    withCredentials: true,
  });
}
export function approveAddonsRequestWithoutPayment(id) {
  return api.patch(
    `addons/request/${id}/approve`,
    {},
    {
      withCredentials: true,
    },
  );
}
export function approveAddonsRequest(id, data) {
  return api.patch(`/addons/request/${id}/approve`, data, { withCredentials: true });
}
export function addExtensionRequest(data) {
  return api.post(`/addons/extension-request`, data, { withCredentials: true });
}

export function approveExtensionAddonsRequest(id) {
  return api.patch(
    `addons/extension-request/${id}/approve`,
    {},
    {
      withCredentials: true,
    },
  );
}
export function editModulePrice(id, data) {
  return api.put(`modules/update/${id}`, { price: data }, { withCredentials: true });
}

export function editThemePrice(id, data) {
  return api.put(`themes/update/${id}`, { price: data }, { withCredentials: true });
}
export function addChargesForCity(data) {
  return api.post(`delivery-charges/add`, data, { withCredentials: true });
}
export function updateChargesForCity(data, id) {
  return api.put(`delivery-charges/${id}`, data, { withCredentials: true });
}
export function changeOrderStatus(data) {
  const { id, status, reason, postman_name, postman_phone, trx_status, order_id, order_source_id, tracking_id, delivery_partner_id, send_sms } = data;
  const dataObj = {
    ...(status ? { status } : {}),
    ...(reason ? { reason } : {}),
    ...(postman_name ? { postman_name } : {}),
    ...(postman_phone ? { postman_phone } : {}),
    ...(trx_status ? { trx_status } : {}),
    ...(order_id ? { order_id } : {}),
    ...(order_source_id ? { order_source_id } : {}),
    ...(data.tracking_id ? { tracking_id: data.tracking_id } : {}),
    ...(data.delivery_partner_id ? { delivery_partner_id: data.delivery_partner_id } : {}),
    ...(data.delivery_partner_label ? { delivery_partner_label: data.delivery_partner_label } : {}),
    ...(typeof send_sms === "boolean" ? { send_sms } : {}),
    // postex related fields
    ...(data.cityName ? { cityName: data.cityName } : {}),
    ...(data.pickupAddressCode ? { pickupAddressCode: data.pickupAddressCode } : {}),
    ...(data.storeAddressCode ? { storeAddressCode: data.storeAddressCode } : {}),
    ...(data.transactionNotes ? { transactionNotes: data.transactionNotes } : {}),
    ...(data.orderNumber ? { orderNumber: data.orderNumber.trim() } : {}),
    ...(data.customerName ? { customerName: data.customerName.trim() } : {}),
    ...(data.customerPhone ? { customerPhone: data.customerPhone.trim() } : {}),
    ...(data.deliveryAddress ? { deliveryAddress: data.deliveryAddress.trim() } : {}),
    ...(data.invoicePayment ? { invoicePayment: Number(data.invoicePayment) } : {}),
    ...(data.items ? { items: data.items.trim() } : {}),
    ...(data.orderDetail ? { orderDetail: data.orderDetail.trim() } : {}),
    // tcs related fields
    ...(data.costCenterCode ? { costCenterCode: data.costCenterCode } : {}),
    ...(data.serviceCode ? { serviceCode: data.serviceCode } : {}),
    ...(data.weightInKg != null ? { weightInKg: Number(data.weightInKg) } : {}),
    ...(data.pieces != null ? { pieces: Number(data.pieces) } : {}),
    ...(data.cityCode ? { cityCode: data.cityCode } : {}),
    ...(typeof data.fragile === "boolean" ? { fragile: data.fragile } : {}),
  };
  return api.patch(`orders/${id}/change-status`, dataObj, {
    withCredentials: true,
  });
}

export const recalculateStatus = async (order_id) => {
  return api.patch(`orders/${order_id}/recalculate-status`, {}, { withCredentials: true });
};
export function changeDeliveryCityStatus(data) {
  return api.patch(`city/${data?.id}/change-delivery-status`, { active: data.active }, { withCredentials: true });
}
export function Changed4uStatus(data) {
  const { shopId, is_d4u_enabled, is_pg_enabled, is_bnpl_enabled } = data;
  const endpoint = shopId ? `shop-options/change-d4u-status/${shopId}` : `shop-options/change-d4u-status`;
  return api.patch(
    endpoint,
    {
      is_d4u_enabled,
      is_pg_enabled,
      is_bnpl_enabled,
    },
    { withCredentials: true },
  );
}

export function addSpots(data) {
  const { place, total_spots, available_spots, price, spot_weight } = data;
  return api.post(`featured-listings/spots`, { place, total_spots, available_spots, price, spot_weight }, { withCredentials: true });
}

export function updateSpot(data) {
  const { id, ...rest } = data;
  return api.patch(`featured-listings/spots/${data?.id}`, rest, { withCredentials: true });
}
export function deleteSpot(spotId) {
  return api.delete(`featured-listings/spots/${spotId}`, { withCredentials: true });
}
export function assignSpots(bookingId, data) {
  return api.patch(`featured-listings/bookings/${bookingId}/assign-spots`, data, { withCredentials: true });
}
export function payFeaturedListingsBookingRequest(bookingId, data) {
  return api.post(`featured-listings/bookings/${bookingId}/add-trx`, { trxData: data }, { withCredentials: true });
}

export function approveFeaturedListingsBookingRequest(bookingId) {
  return api.patch(`featured-listings/bookings/${bookingId}/confirm`, {}, { withCredentials: true });
}

export function rejectFeaturedListingsBookingRequest(bookingId) {
  return api.patch(`featured-listings/bookings/${bookingId}/reject`, {}, { withCredentials: true });
}
export function AddVoucher(data) {
  return api.post(`vouchers`, { ...data }, { withCredentials: true });
}
export function UpdateVoucher(id, data) {
  return api.patch(`vouchers/${id}`, { ...data }, { withCredentials: true });
}
export function deleteVoucher(id) {
  return api.delete(`vouchers/${id}`, { withCredentials: true });
}

export function AddCommision(data) {
  return api.post(`platform-commission/add`, data, { withCredentials: true });
}
export function EditPaltformCommision(id, data) {
  return api.put(`platform-commission/${id}`, data, { withCredentials: true });
}

export function DeletePaltformCommision(id) {
  return api.delete(`platform-commission/${id}`, { withCredentials: true });
}
export function SellerPaymentProcessRequest(data) {
  return api.patch(`/seller-payments`, data, { withCredentials: true });
}

export function UploadProof(data) {
  return api.post(`${process.env.REACT_APP_URL_IMAGE_CDN}/images/d4u-seller-payments/transaction`, data, { withCredentials: true });
}
export function processSellerPayments(data) {
  return api.patch(`/seller-payments/payment`, data, { withCredentials: true });
}
export function updateOrderConfigurations(data) {
  return api.put(`d4u-config/update`, data, { withCredentials: true });
}
// Marketplace options
// export default function UploadBanner(data) {
//   console.log(data);

//   return api.post(`${process.env.REACT_APP_URL_IMAGE_CDN}/marketplace/home-page-banners`, data, {
//     withCredentials: true,
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   })
// }

export function createD4uOrder(data) {
  return api.post(`/orders `, data, { withCredentials: true });
}
export function moveD4uOrderToTM(data) {
  return api.post(`/orders/move-to-techbazaar-mall`, data, { withCredentials: true });
}
export function sendSMS(data) {
  return api.post(`/sms-notification/send?recipientType=marketplace`, data, { withCredentials: true }); // TODO: needs to change it
}

export function uploadReviewImages(formData) {
  return axios.post(`${process.env.REACT_APP_URL_IMAGE_CDN}/marketplace/reviews`, formData, {
    headers: { Accept: "application/json", "content-type": "multipart/form-data" },
  });
}

export function createDummyListingReview(data) {
  return api.post(`/listing-reviews/dummy`, data, { withCredentials: true });
}

export function updateDummyListingReview(id, data) {
  return api.patch(`/listing-reviews/dummy/${id}`, data, { withCredentials: true });
}

export function deleteDummyListingReview(id) {
  return api.delete(`/listing-reviews/dummy/${id}`, { withCredentials: true });
}

export function bulkCreateDummyListingReviews(data) {
  return api.post(`/listing-reviews/dummy/bulk`, data, { withCredentials: true });
}

export function approveListingReview(id) {
  return api.post(`/listing-reviews/approvals/${id}/approve`, {}, { withCredentials: true });
}

export function rejectListingReview(id) {
  return api.post(`/listing-reviews/approvals/${id}/reject`, {}, { withCredentials: true });
}

export function bulkApproveListingReviews(data) {
  return api.post(`/listing-reviews/approvals/bulk-approve`, data, { withCredentials: true });
}

export function bulkRejectListingReviews(data) {
  return api.post(`/listing-reviews/approvals/bulk-reject`, data, { withCredentials: true });
}

export function markAsSpam(id, reason) {
  return api.patch(`/orders/mark-as-spam/${id}`, { reason }, { withCredentials: true });
}

export function unmarkSpam(id) {
  return api.patch(`/orders/unmark-spam/${id}`, {}, { withCredentials: true });
}

export function markAsDummy(id) {
  return api.patch(`/orders/mark-as-dummy/${id}`, {}, { withCredentials: true });
}

export function unmarkDummy(id) {
  return api.patch(`/orders/unmark-dummy/${id}`, {}, { withCredentials: true });
}

export function AddSale(payload) {
  return api.post(`/sale`, payload, { withCredentials: true });
}

export function UpdateSale(id, payload) {
  return api.patch(`/sale/${id}`, payload, { withCredentials: true });
}

export function toggleSaleStatus(id) {
  return api.patch(`/sale/${id}/toggle-status`, {}, { withCredentials: true });
}

export function LegacychangeOrderStatus(data) {
  const { id, status, reason, postman_name, postman_phone, trx_status } = data;
  const dataObj = {
    ...(status ? { status } : {}),
    ...(reason ? { reason } : {}),
    ...(postman_name ? { postman_name } : {}),
    ...(postman_phone ? { postman_phone } : {}),
    ...(trx_status ? { trx_status } : {}),
  };
  return api.patch(`d4u-orders/${id}/change-status`, dataObj, {
    withCredentials: true,
  });
}

export function LegacyAddVoucher(data) {
  return api.post(`d4u-orders/vouchers`, { ...data }, { withCredentials: true });
}
export function LegacyUpdateVoucher(id, data) {
  return api.patch(`d4u-orders/vouchers/${id}`, { ...data }, { withCredentials: true });
}
export function LegacydeleteVoucher(id) {
  return api.delete(`d4u-orders/vouchers/${id}`, { withCredentials: true });
}

export function LegacySellerPaymentProcessRequest(data) {
  return api.patch(`/d4u-seller-payments`, data, { withCredentials: true });
}

export function LegacycreateD4uOrder(data) {
  return api.post(`/d4u-orders `, data, { withCredentials: true });
}
export function LegacymoveD4uOrderToTM(data) {
  return api.post(`/d4u-orders/move-to-techbazaar-mall`, data, { withCredentials: true });
}

export function addDeliveryPartner(data) {
  return api.post(`delivery-partner`, data, { withCredentials: true });
}

export function updateDeliveryPartner(data, id) {
  return api.patch(`delivery-partner/${id}`, data, { withCredentials: true });
}
export function deleteDeliveryPartner(id) {
  return api.delete(`delivery-partner/${id}`, { withCredentials: true });
}

export function addLegacyDeliveryChargesForCity(data) {
  return api.post(`d4u-delivery-charges/add`, data, { withCredentials: true });
}

// Daily expenses (marketplace-wide)
export function upsertDailyExpense(data) {
  return api.post(`/daily-expense`, data, { withCredentials: true });
}

export function deleteDailyExpense(date) {
  return api.delete(`/daily-expense/${date}`, { withCredentials: true });
}
export function updateLegacyDeliveryChargesForCity(data, id) {
  return api.put(`d4u-delivery-charges/${id}`, data, { withCredentials: true });
}

export function getOrderPostexCities() {
  return api.get(`orders/postex/cities`, { withCredentials: true });
}

export function getOrderPostexMerchantAddresses(cityName) {
  return api.get(`orders/postex/merchant-addresses`, {
    withCredentials: true,
    params: cityName ? { cityName } : {},
  });
}

export function getOrderPostexPreview(orderId, pickupAddressCode) {
  return api.post(`orders/${orderId}/postex-preview`, { pickupAddressCode }, { withCredentials: true });
}

export function getOrderPostexAirwayBill(trackingNumber) {
  return api.get(`orders/postex/airway-bill/${trackingNumber}`, {
    withCredentials: true,
    responseType: "blob",
  });
}

export function getOrderTcsCities() {
  return api.get(`orders/tcs/cities`, { withCredentials: true });
}

export function getOrderTcsCostCenters() {
  return api.get(`orders/tcs/cost-centers`, { withCredentials: true });
}

export function getOrderTcsPreview(orderId, costCenterCode) {
  return api.post(`orders/${orderId}/tcs-preview`, { costCenterCode }, { withCredentials: true });
}

export function getOrderTcsLabel(consignmentNo) {
  return api.get(`orders/tcs/label/${consignmentNo}`, {
    withCredentials: true,
    responseType: "blob",
  });
}
export function getPostexCities() {
  return api.get(`d4u-orders/postex/cities`, { withCredentials: true });
}

export function getPostexMerchantAddresses(cityName) {
  return api.get(`d4u-orders/postex/merchant-addresses`, {
    withCredentials: true,
    params: cityName ? { cityName } : {},
  });
}

export function postexPreview(orderId, pickupAddressCode) {
  return api.post(`d4u-orders/${orderId}/postex-preview`, { pickupAddressCode }, { withCredentials: true });
}

export function shipWithPostex(orderId, data) {
  return api.post(`d4u-orders/${orderId}/ship-with-postex`, data, { withCredentials: true });
}

export function getPostexAirwayBill(trackingNumber) {
  return api.get(`d4u-orders/postex/airway-bill/${trackingNumber}`, {
    withCredentials: true,
    responseType: "blob",
  });
}

export function createAlertMessage(data) {
  return api.post(`/alert-messages`, data, { withCredentials: true });
}

export function updateAlertMessage(id, data) {
  return api.put(`/alert-messages/${id}`, data, { withCredentials: true });
}

export function activateAlertMessage(id) {
  return api.post(`/alert-messages/${id}/activate`, {}, { withCredentials: true });
}

export function deactivateAlertMessage(id) {
  return api.post(`/alert-messages/${id}/deactivate`, {}, { withCredentials: true });
}

export function deleteAlertMessage(id) {
  return api.delete(`/alert-messages/${id}`, { withCredentials: true });
}

export function updateMarketplaceOptions(data) {
  return api.put(`/marketplace-options/update`, data, { withCredentials: true });
}

export function createApiToken(data) {
  return api.post("/api-tokens", data, { withCredentials: true });
}

export function revokeApiToken(id) {
  return api.delete(`/api-tokens/${id}`, { withCredentials: true });
}
